import { useState } from "react";
import PropTypes from "prop-types";
import { Button } from "primereact/button";
import { useIntl } from "react-intl";
import SaveReportDialog from "./SaveReportDialog";

// "Save" on a report screen. With no saved report open it asks for a name and
// creates one; with a saved report open, "Save" updates it in place and
// "Save as new" asks for a name and creates another.
const SavedReportActions = ({
  openSavedReport,
  requesting = false,
  buildSavedReport,
  createSavedReport,
  updateSavedReport,
}) => {
  const intl = useIntl();
  const [isDialogVisible, setIsDialogVisible] = useState(false);

  const handleSave = () => {
    if (openSavedReport) {
      // Save changes the level and filters, not the name: the stored name is
      // kept, which may have been changed in another tab since the report
      // was opened here (B-BUG-4).
      updateSavedReport({
        id: openSavedReport.id,
        ...buildSavedReport(openSavedReport.name),
        keepStoredName: true,
      });
    } else {
      setIsDialogVisible(true);
    }
  };

  const handleCreate = (name) => {
    createSavedReport(buildSavedReport(name));
    setIsDialogVisible(false);
  };

  return (
    <div className="edexlms-page-actions flex gap-2">
      <Button
        icon="pi pi-bookmark"
        size="small"
        type="button"
        disabled={requesting}
        label={intl.formatMessage({ id: "save" })}
        onClick={handleSave}
      />
      {(openSavedReport && (
        <Button
          icon="pi pi-copy"
          size="small"
          type="button"
          outlined
          disabled={requesting}
          label={intl.formatMessage({ id: "saved_report_save_as_new" })}
          onClick={() => setIsDialogVisible(true)}
        />
      )) ||
        null}
      <SaveReportDialog
        visible={isDialogVisible}
        title={intl.formatMessage({ id: "saved_report_dialog_title" })}
        requesting={requesting}
        onHide={() => setIsDialogVisible(false)}
        onSubmit={handleCreate}
      />
    </div>
  );
};

SavedReportActions.propTypes = {
  openSavedReport: PropTypes.object,
  requesting: PropTypes.bool,
  buildSavedReport: PropTypes.func.isRequired,
  createSavedReport: PropTypes.func.isRequired,
  updateSavedReport: PropTypes.func.isRequired,
};

export default SavedReportActions;
